import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerticalAlignJustify = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 15",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "b",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 15
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-1",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 15
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		id: "a",
		clipPath: "url(#b)",
		transform: "matrix(1.32523, 0, 0, 1.355831, -2.523453, -5.337469)",
		children: [/* @__PURE__ */ _jsx("g", { transform: "translate(-1.95 -4.5)" }), /* @__PURE__ */ _jsxs("g", {
			id: "g-1",
			clipPath: "url(#clip-1)",
			transform: "matrix(0.754586, 0, 0, 0.754586, 1.904162, 3.936676)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 15,
				fill: "#fff",
				fillOpacity: 0
			}), /* @__PURE__ */ _jsxs("g", {
				transform: "translate(-1.95 -4.5)",
				children: [/* @__PURE__ */ _jsxs("g", {
					transform: "translate(3 5)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M18,12.5H0v1H18Z",
						fillRule: "evenodd"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M18,.5H0v1H18Z",
						fillRule: "evenodd"
					})]
				}), /* @__PURE__ */ _jsxs("g", {
					transform: "matrix(0, -1, 1, 0, 9.005, 21.995001)",
					children: [/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("rect", {
							width: 7.951,
							height: 1,
							x: 5.975,
							y: 2.5
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 1,
							height: 4,
							transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 7.75369, 0.166)"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 1,
							height: 4,
							transform: "matrix(-0.707107, 0.707107, -0.707107, -0.707107, 8.46069, 5.116)"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 1,
							height: 4,
							transform: "matrix(-0.707107, -0.707107, 0.707107, -0.707107, 12.24631, 5.824)"
						}),
						/* @__PURE__ */ _jsx("rect", {
							width: 1,
							height: 4,
							transform: "matrix(0.707107, -0.707107, 0.707107, 0.707107, 11.539311, 0.874)"
						})
					] }), /* @__PURE__ */ _jsx("g", { transform: "translate(15)" })]
				})]
			})]
		})]
	})]
});
export default SvgVerticalAlignJustify;
